<template>
  <el-popover placement="bottom" width="500" trigger="click" :offset="40">
    <el-table-wrapper :data="legendData" :columns="legendTableColumns" :column-default="columnDefault" :max-height="300" :pagination="false">
      <template slot-scope="scope" slot="desc-slot">
        <span v-html="scope.row.desc"></span>
      </template>
    </el-table-wrapper>
    <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
  </el-popover>
</template>

<script>
import { columnDefault } from '@/constants/table';

export default {
  name: 'WLogRegexSearchInfoButton',
  data() {
    return {
      columnDefault,
      legendData: [
        {
          value: '.',
          desc: '하나의 문자와 매치 됩니다. <br/> ex) abcde > ab...',
        },
        {
          value: '+',
          desc: '앞 패턴을 한번 이상 반복합니다. <br/> ex) aaabbb > a+b+',
        },
        {
          value: '.*',
          desc: '모든 문자 조건을 매치 합니다. <br/> ex) aaabbb > a.*b.* / a.*b.*c.*',
        },
        {
          value: '?',
          desc: '0번 또는 1번 매치 됩니다. <br/> ex) aaabbb > aaa?bbb?',
        },
        {
          value: '{NUMBER}',
          desc: '앞 문자의 발생 횟수를 지정합니다. <br/> ex) aaabbb > a{3}b{3}',
        },
        {
          value: '()',
          desc: '소괄호 안에 입력값을 <br/> 패턴으로 인식합니다. <br/> ex) ababab > (ab)+',
        },
        {
          value: '|',
          desc: 'OR 연산자로 사용됩니다. <br/> ex) aabb > aa(cc|bb)',
        },
        {
          value: '[]',
          desc: '대괄호 안에 문자들을 그룹으로<br/>매치 됩니다, <br/> 또한 ^을 사용해 제외조건을 <br/>설정할 수 있습니다. <br/> ex) abcd > [a-d]+ / [^e-z]',
        },
        {
          value: '<>',
          desc: '숫자 범위를 지정합니다. <br/> ex) foo80 foo <1-100>',
        },
      ],
      legendTableColumns: [
        {
          prop: 'value',
          label: '표현식',
          searchable: false,
        },
        {
          prop: 'desc',
          label: '설명',
          searchable: false,
          scopedSlot: 'desc-slot',
        },
      ],
    };
  },
};
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/LogRegexSearchInfoButton.vue